import microuniversoApi from "app/api/microuniversoApi";
import store from "app/redux/store/store";
import globalMU from "globalMU";

export async function dumpOrcamento(nivel:number, nomeDump:string = null) {

    if (globalMU.isNullOrEmpty(store.getState().orcamento?.IdentificadorOrcamento)) {
        console.warn(`nao existe um orcamento. impossivel realizar dump`)
        return
    }

    const identificadorOrcamento = store.getState().orcamento.IdentificadorOrcamento

    console.log(`realizando dump do orcamento ${identificadorOrcamento}. sera exibido abaixo o endereco do arquivo de dump no servidor de IIS quando o dump terminar. pode levar alguns segundos ou mais de 1 minuto dependendo do tamanho do orcamento e do nivel informado`)

    const resultado = await microuniversoApi.Orcamento.DumpOrcamento(identificadorOrcamento, nivel, nomeDump)

    console.log(resultado)
}